import { render, staticRenderFns } from "./AllForums.vue?vue&type=template&id=1bf608d8&"
import script from "./AllForums.vue?vue&type=script&lang=js&"
export * from "./AllForums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports